/**
 * Deep merge utility to replace lodash merge
 * Recursively merges objects while preserving nested structure
 * Non-mutating version that creates new objects
 */
const isObject = (item) =>
  item !== null && typeof item === 'object' && !Array.isArray(item);

/**
 * Merge two objects deeply
 */
const mergeTwo = (target, source) => {
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (key in target && isObject(target[key])) {
          output[key] = mergeTwo(target[key], source[key]);
        } else {
          output[key] = { ...source[key] };
        }
      } else if (Array.isArray(source[key])) {
        output[key] = [...source[key]];
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
};

/**
 * Deep merge multiple objects
 * @param {...object} objects - Objects to merge
 * @returns {object} - Merged object
 */
export const deepMerge = (...objects) => {
  if (objects.length === 0) return {};
  if (objects.length === 1) return { ...objects[0] };

  return objects.reduce((acc, obj) => {
    if (!obj || typeof obj !== 'object') return acc;
    return mergeTwo(acc, obj);
  }, {});
};

export default deepMerge;
